import {
    addressList
} from '@/api/scooter';
import {
    scooterVip
} from '@/api/scooter'
import store from '@/utils/store';

const actions = {
    // 获取代步车门店列表
    addressList(context, isReLoad = false) {
        store.loadCacheData(context, 'addressList', addressList, null, {
            isReLoad: isReLoad
        });
    },
    // 获取用户权限
    scooterVip(context, isReLoad = true) {
        store.loadCacheData(context, 'scooterVip', scooterVip, null, {
            isReLoad: isReLoad
        });
    }
}
export default actions